// Description: Page to add one list with one integration
// Updated: 25/09/2025
// Author: Simon Franklin

// React
import React, { useEffect } from "react";

// Material UI Components
import {
    Box,
    Button,
    CircularProgress,
    Skeleton,
    Typography,
} from "@mui/material";

// Components and Functions for the project
import { consultIntegrations } from "../../api/aws/Integrations/listIntegrations";
import use123zapStore from "../../context/123zapStore";
import HeaderPage from "../../components/HeaderPage/HeaderPage";
import { useNavigate, useParams } from "react-router-dom";
import { notify, removeKey } from "../../utils/utils";
import CustomDynamicInput from "../../components/Input/CustomDynamicInput";
import CampaignModal from "../../components/Modals/CampaignModal";
import themeColors from "../../components/ThemeColors/ThemeColors";

// Render The Component
const AddSheetsIntegrationInvoice = () => {
    const { integration } = useParams();
    const creatingCampaignWithHelpMode = JSON.parse(sessionStorage.getItem("creating_campaign")) || null;
    const planoAtual = use123zapStore((state) => state.planoAtual);
    const integrations = use123zapStore((state) => state.integrations);
    const setIntegrations = use123zapStore((state) => state.setIntegrations);
    const setAlreadyFetchSheets = use123zapStore((state) => state.setAlreadyFetchSheets)
    const alreadyFetchIntegrations = use123zapStore(
        (state) => state.alreadyFetchIntegrations
    );
    const setAlreadyFetchIntegrations = use123zapStore(
        (state) => state.setAlreadyFetchIntegrations
    );
    const [loading, setLoading] = React.useState(false);
    const [formState, setFormState] = React.useState({});
    const [disableButton, setDisableButton] = React.useState(false);
    const [openModalCampaign, setOpenModalCampaign] = React.useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (
            planoAtual !== 'FreeZap' &&
            planoAtual !== 'StartZap' &&
            planoAtual !== 'ProZap' &&
            planoAtual !== 'UltraZap' &&
            planoAtual !== null
        ) {
            navigate('/acesso-restrito');
        }
    }, [planoAtual]);

    const findName = (name) => {
        if (name === "sgp") {
            return "SGP";
        } else if (name === "controllr") {
            return "Controllr ISP";
        } else if (name === "hubsoft") {
            return "HubSoft";
        } else if (name === "elitesoft") {
            return "EliteSoft";
        } else if (name === "sienge") {
            return "Sienge";
        }
    };

    const selectedIntegration = integrations.filter(
        (item) => item.title === findName(integration)
    )[0];

    React.useEffect(() => {
        (async () => {
            if (alreadyFetchIntegrations === false) {
                setLoading(true);
                consultIntegrations()
                    .then((response) => {
                        setIntegrations(response.data);
                    })
                    .finally(
                        () => (setLoading(false), setAlreadyFetchIntegrations(true))
                    );
            }
        })();
    }, []);

    const initializeFormState = (fields) => {
        return fields.reduce(
            (acc, field) => {
                acc[field] = "";
                return acc;
            },
            {
                title: "",
                desc: "",
            }
        );
    };

    React.useEffect(() => {
        if (selectedIntegration) {
            setFormState(initializeFormState(formData[selectedIntegration.title]));
        }
    }, [selectedIntegration]);

    const formData = {
        "Controllr ISP": [
            "data_vencimento_inicio",
            "data_vencimento_fim",
            "status",
        ],
        HubSoft: [
            // "busca",
            //   "valor_busca",
            //   "tipo_data",
            "data_inicio",
            "data_fim",
            //   "tipo_resultado",
            "apenas_quitado",
            "apenas_em_aberto",
            //   "valor_zerado",
            // "exibir_pix_copia_cola",
            //   "exibir_fatura_inativa",
            //   "exibir_faturas_renegociacao",
            //   "status_cadastro_cliente",
            //   "campos",
        ],
        SGP: [
            //   "cliente_id",
            //   "cpfcnpj",
            //   "plano",
            //   "contrato",
            "status",
            //   "portador",
            //   "contrato_status",
            //   "tipo_servico",
            "data_vencimento_inicio",
            "data_vencimento_fim",
            //   "campos",
        ],
        EliteSoft: [
            "data_vencimento_inicio",
            "data_vencimento_fim",
            "status"
        ],
        Sienge: [
            "data_vencimento_inicio",
            "data_vencimento_fim",
            "status"
        ]
    };

    const dateKeys = [
        "data_vencimento_inicio",
        "data_vencimento_fim",
        "data_inicio",
        "data_fim",
    ];

    function formatDate(isoString) {
        const date = new Date(isoString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    function formatFormStateDates(objectData) {
        const formattedState = { ...objectData };

        dateKeys.forEach((key) => {
            const value = formattedState[key];
            if (value) {
                if (typeof value === "object" && value.$d instanceof Date) {
                    formattedState[key] = formatDate(value.$d);
                } else if (value instanceof Date) {
                    formattedState[key] = formatDate(value);
                } else if (typeof value === "string" && value.includes("T")) {
                    formattedState[key] = formatDate(value);
                }
            }
        });

        return formattedState;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setDisableButton(true);

        const cleanedFormState = removeKey(formState, "status_invoice");
        const formattedFormState = formatFormStateDates(cleanedFormState);

        const finalUrl = (integration) => {
            if (integration === "SGP") {
                return "sgp";
            } else if (integration === "Controllr ISP") {
                return "controllr";
            } else if (integration === "HubSoft") {
                return "hubsoft";
            } else if (integration === "EliteSoft") {
                return "elitesoft";
            } else if (integration === "Sienge") {
                return "sienge";
            }
        };

        try {
            const token = localStorage.getItem("jwt_token");
            const clientId = localStorage.getItem("idToken");

            if (!token) throw new Error("Token de autenticação não encontrado");
            if (!clientId) throw new Error("ID do cliente não encontrado");

            await fetch(
                `${process.env.REACT_APP_BACKEND_AWS_URL}/erp/${finalUrl(
                    selectedIntegration.title
                )}/invoices/add`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `${token}`,
                        Client_ID: `${clientId}`,
                    },
                    body: JSON.stringify(formattedFormState),
                }
            )
                .then((response) => response.json())
                .then((response) => {
                    if (response.status === "success") {
                        if (creatingCampaignWithHelpMode) {
                            setOpenModalCampaign(true);
                        } else {
                            navigate('/listagens');
                        }

                        notify("Success", "Listagem criada com sucesso", true);
                        setAlreadyFetchSheets(false);
                    }
                });
        } catch (error) {
            console.error(error);
            throw new Error("Erro ao buscar dados da API");
        } finally {
            setDisableButton(false);
        }
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
            <HeaderPage />
            <Box
                component="main"
                sx={{
                    display: "flex",
                    padding: "32px",
                    gap: { xs: "24px", sm: "64px" },
                    justifyContent: { xs: "normal", sm: "space-between" },
                    minHeight: "calc(100vh - 100px)",
                    minWidth: "100%",
                    flexDirection: { xs: "column", sm: "row" }
                }}
            >
                <Box
                    component="section"
                    sx={{
                        width: { xs: "100%", sm: "calc(100% - 32px)" }
                    }}
                >
                    {loading === false &&
                        integrations.length > 0 &&
                        selectedIntegration !== null &&
                        typeof selectedIntegration === "object" ? (
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                                height: "auto",
                                borderRadius: "4px",
                                border: "1px solid #E0E0E0",
                                padding: "24px",
                                backgroundColor: "#fff",
                                gap: "24px",
                            }}
                        >
                            <Box
                                component="img"
                                src={selectedIntegration.logo}
                                alt={`logo ${selectedIntegration.title}`}
                                sx={{
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "4px",
                                    backgroundColor: "#bdbdbd",
                                    minWidth: "32px",
                                    minHeight: "32px",
                                }}
                            />
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "12px",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: { xs: "13px", sm: "16px" },
                                    }}
                                >
                                    {selectedIntegration.title}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontWeight: 400,
                                        fontSize: { xs: "12px", sm: "16px" },
                                    }}
                                >
                                    {selectedIntegration.desc}
                                </Typography>
                            </Box>
                        </Box>
                    ) : (
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                                height: "220px",
                                borderRadius: "4px",
                                border: "1px solid #E0E0E0",
                                padding: "24px",
                                backgroundColor: "#fff",
                                gap: "24px",
                            }}
                        >
                            <Skeleton
                                variant="rectangular"
                                width={32}
                                height={32}
                                sx={{ borderRadius: "4px" }}
                            />
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "12px",
                                }}
                            >
                                <Skeleton
                                    variant="text"
                                    sx={{ fontSize: { xs: "13px", sm: "16px" }, width: "50px" }}
                                />
                                <Box>
                                    <Skeleton
                                        variant="text"
                                        sx={{ fontSize: { xs: "13px", sm: "16px" } }}
                                    />
                                    <Skeleton
                                        variant="text"
                                        sx={{ fontSize: { xs: "13px", sm: "16px" } }}
                                    />
                                    <Skeleton
                                        variant="text"
                                        sx={{ fontSize: { xs: "13px", sm: "16px" } }}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    )}
                </Box>
                <Box
                    component="section"
                    sx={{
                        width: { xs: "100%", sm: "calc(100% - 32px)" }
                    }}
                >
                    <Box
                        component="form"
                        onSubmit={handleSubmit}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            border: "1px solid #d9d9dc",
                            height: "100%",
                            backgroundColor: "#fff",
                            padding: { xs: "24px", sm: "48px" },
                        }}
                    >
                        {Object.keys(formState).length > 0 ? (
                            <>
                                {Object.keys(formState).filter((item) => item !== "apenas_em_aberto").map((item, index) => (
                                    <CustomDynamicInput key={index} field={item} formState={formState} setFormState={setFormState} />
                                ))}
                            </>
                        ) : (
                            <>
                                {
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "100%",
                                        }}
                                    >
                                        <CircularProgress style={{ color: "rgb(52, 152, 219)" }} />
                                    </div>
                                }
                            </>
                        )}

                        <Button
                            onClick={() => navigate(-1)}
                            variant="outlined"
                            disabled={disableButton}
                            type="button"
                            sx={{
                                height: "54px",
                                width: "100%",
                                borderRadius: "6px",
                                fontSize: "18px",
                                fontWeight: 500,
                                marginTop: "2px",
                            }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            disabled={disableButton}
                            type="submit"
                            sx={{
                                height: "54px",
                                width: "100%",
                                borderRadius: "6px",
                                fontSize: "18px",
                                fontWeight: 500,
                                marginTop: "16px",
                            }}
                        >
                            Conectar
                        </Button>
                    </Box>
                </Box>
            </Box>
            <CampaignModal
                cancelText="Adicionar mais uma listagem"
                confirmText="Retornar ao formulário"
                subTitle={"Percebemos que você está configurando uma campanha. Gostaria de retornar ao formulário?"}
                isOpen={openModalCampaign}
                onClose={() => setOpenModalCampaign(false)}
                onCancel={() => navigate("/listagens/adicionar")}
                onConfirm={() => (navigate("/campanhas/adicionar"), sessionStorage.setItem("ReturToCampaign", true))}
                title={"Listagem adicionada com sucesso"}
                iconColor={themeColors.purple400}
            />
        </Box>
    );
};

export default AddSheetsIntegrationInvoice;
